import { HttpClient } from "@angular/common/http";
import { Injectable, OnDestroy } from "@angular/core";
import { BehaviorSubject, Observable, ReplaySubject } from "rxjs";

import { environment } from "../../../../../environments/environment";
import { Utils } from "../../../../shared/utils/utils";
import { UserMe } from "../interfaces/user-me.interface";
import { initialState } from "../state/recertification.state";
@Injectable({
  providedIn: "root",
})
export class RecertificationService implements OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  public manager = new BehaviorSubject<UserMe>(initialState);

  constructor(private readonly _http: HttpClient) {}

  attest(): Observable<unknown> {
    const headers = Utils.generateDefaultHeader();
    return this._http.post(
      `${environment.logonPortalBaseUrl}/user-accesses/me/attestation`,
      {},
      { headers },
    );
  }

  decline() {
    const headers = Utils.generateDefaultHeader();
    return this._http.delete(
      `${environment.logonPortalBaseUrl}/user-accesses/me`,
      { headers },
    );
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
